import { css } from '@emotion/react';

export const buttonBase = css`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 50%;
  background-color: var(--colors-silver);
  transition: background-color var(--duration-base) linear;
  cursor: pointer;

  &:hover {
    background-color: var(--colors-silver-gray);
  }
`;
